import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker, Input } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const RejectContract = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        rejectedOnDate: values.rejectedOnDate?.format("YYYY-MM-DD"),
        rejectionReason: values.rejectionReason,
      };
      // await BOM.SendReq(apiConfig.rejectContract, { id, ...payload });
      console.log("RejectContract payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Contract rejected.");
      navigate(-2);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to reject contract.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.manageTBContract}>
      <TopContent pageTitle={labelConfig.tbContract} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            {/* Warning banner */}
            <div
              style={{
                background: "#FEF3F2",
                border: "1px solid #FECDCA",
                borderRadius: 12,
                padding: "14px 18px",
                marginBottom: 24,
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
              }}
            >
              <span style={{ fontSize: 20, lineHeight: 1 }}>⚠️</span>
              <div>
                <p
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    color: "#B42318",
                    fontSize: 14,
                  }}
                >
                  You are about to reject this contract
                </p>
                <p
                  style={{ margin: "4px 0 0", color: "#912018", fontSize: 13 }}
                >
                  Please provide the rejection date and reason before
                  proceeding.
                </p>
              </div>
            </div>

            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Reject Contract
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              {/* Rejected On Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Rejected On Date{" "}
                        <Tooltip title="The date on which this contract is rejected.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="rejectedOnDate"
                    rules={[
                      { required: true, message: "Rejection date is required" },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Rejection Reason */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Rejection Reason{" "}
                        <Tooltip title="Describe why this contract is being rejected.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="rejectionReason"
                    rules={[
                      {
                        required: true,
                        message: "Rejection reason is required",
                      },
                      {
                        min: 5,
                        message: "Please provide a more descriptive reason",
                      },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="e.g. Incorrect pricing"
                      style={{
                        resize: "none",
                        borderRadius: 8,
                        fontSize: 14,
                        padding: "10px 12px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #B42318",
                      background: "#B42318",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Reject Contract
                  </button>
                </Col>
              </Row>
              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(RejectContract);
